import OtpInputGroup from 'components/OtpInputGroup/OtpInputGroup';
import { withOtpInputGroupProps } from 'viewModel/otpInputGroup/withOtpInputGroupProps';

export default withOtpInputGroupProps(OtpInputGroup);
